function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DialogsComponent from '@/components/DialogsComponent.vue';
import WorkEnvironmentsService from '@/services/work_env_service';
import FormResourceRequestComponent from '@/apps/analytic-services/components/FormResourceRequestComponent';
import FormRequestUpdateComponent from '@/apps/analytic-services/components/FormRequestUpdateComponent';
import LineChart from '@/components/LineChart';
import utils from '@/utils/firebase';
import { mapMutations } from 'vuex';
import DragFileComponent from '@/components/DragFileComponent.vue';
import AnalyticService from '@/apps/analytic-services/services/analytic_service.js';
import mlops_service from '@/apps/analytic-services/services/mlops_service';
import firebase from 'firebase';
import 'firebase/auth';
import 'firebase/storage';
import tasks from '@/js/tasks';
import { LIST_ROLES, LIST_DOMAINS, ROLES_LIST } from '@/js/constants';
var firebaseDataOperation = utils.getFirebaseDataOperation();
export default {
  name: 'MyResourcesPage',
  components: {
    FormRequestUpdateComponent: FormRequestUpdateComponent,
    LineChart: LineChart,
    FormResourceRequestComponent: FormResourceRequestComponent,
    DialogsComponent: DialogsComponent,
    DragFileComponent: DragFileComponent
  },
  data: function data() {
    var _ref;
    return _ref = {
      DIALOG_PIPELINE: 'DIALOG_PIPELINE',
      pipeline_aux: {
        python_file: {},
        yaml_file: {}
      },
      key_table: 1,
      func_aux: null,
      parameters: [],
      new_aux: [],
      pipelines: [],
      indiceModal: -1
    }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "key_table", null), "archivos", []), "pdf", null), "mode", null), "all_routes", []), "mlops_projects", []), "mlops_configs", []), "config", ''), "project", ''), "key_aux", null), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "response", null), "model_view", {}), "parameter_types", [{
      value: 'str',
      text: 'String'
    }, {
      value: 'int',
      text: 'Number'
    }, {
      value: 'float',
      text: 'Float'
    }, {
      value: 'boolean',
      text: 'Boolean'
    }, {
      value: 'typing.List',
      text: 'List'
    }, {
      value: 'typing.Dict',
      text: 'Object'
    }]), "labels", []), "delete_pipelines", []), "key_archivos", 2), "envars", []), "key_envars", 1), "headers_envars", [{
      text: 'Key',
      value: 'key'
    }, {
      text: '¿Archivo?',
      value: 'is_file'
    }, {
      text: 'Value',
      value: 'value'
    }, {
      text: 'Acciones',
      value: 'actions'
    }]), "archivos_env", []);
  },
  computed: {
    headers: function headers() {
      return [{
        text: this.translate('table_my_work_envs.notebook'),
        value: 'instance_name'
      }, {
        text: this.translate('table_my_work_envs.project_gcp'),
        value: 'pr_name'
      }, {
        text: this.translate('table_my_work_envs.link'),
        value: 'notebook_url'
      }, {
        text: this.translate('table_my_work_envs.status'),
        value: 'status'
      }, {
        text: this.translate('table_my_work_envs.actions'),
        value: 'actions'
      }];
    },
    headers_terms: function headers_terms() {
      return [{
        text: 'Nombre',
        value: 'name'
      }, {
        text: 'Descripción',
        value: 'description'
      }, {
        text: 'Tipo',
        value: 'type'
      }, {
        text: 'Por defecto',
        value: 'default'
      }, {
        value: 'actions',
        sortable: false
      }];
    },
    headers_tabla: function headers_tabla() {
      return [{
        text: 'Nombre',
        value: 'name'
      }, {
        text: 'Version',
        value: 'version'
      }, {
        value: 'actions',
        text: 'Acciones',
        sortable: false
      }];
    },
    headers_archivos: function headers_archivos() {
      return [{
        text: 'Archivo',
        value: 'archivo'
      }, {
        text: 'Nombre',
        value: 'name'
      }, {
        value: 'actions',
        sortable: false
      }];
    },
    headers_label: function headers_label() {
      return [{
        text: 'Label',
        value: 'label'
      }, {
        text: 'Valor',
        value: 'value'
      }, {
        value: 'actions',
        sortable: false
      }];
    },
    statusColor: function statusColor() {
      return function (instance) {
        var status = instance.status;
        return status === 'ACTIVE' ? 'green' : status === 'STOPPED' ? 'red' : 'info';
      };
    },
    breadcrumbs: function breadcrumbs() {
      return [{
        text: this.traductor('titles.ml_requests'),
        disabled: false,
        href: '/#/ml/requests'
      }, {
        text: this.mode == 'view' ? 'Ver solicitud' : this.mode == 'edit' ? 'Actualizar Solicitud' : 'Crear solicitud Vertex Pipeline',
        disabled: true
      }];
    },
    isMLSteward: function isMLSteward() {
      return window.userInfo.userRoles.includes(ROLES_LIST.ML_STEWARD);
    },
    getMLProjects: function getMLProjects() {
      if (this.mode == "view") {
        return this.mlops_projects;
      } else {
        return this.mlops_projects.filter(function (e) {
          return e.created_user == window.userInfo.email;
        });
      }
    },
    onGetArchivosEnv: function onGetArchivosEnv() {
      var _this = this;
      var items = this.mlops_projects.find(function (x) {
        return x.id == _this.project;
      }) ? this.mlops_projects.find(function (x) {
        return x.id == _this.project;
      }).archivos : [];
      var arcs = [];
      this.archivos.forEach(function (x) {
        arcs.push({
          name: x.name,
          route: x.archivo_file && x.archivo_file.route ? x.archivo_file.route : x.name,
          from_pipe: true
        });
      });
      return items.concat(arcs);
    },
    getNameFolderProject: function getNameFolderProject() {
      var _this2 = this;
      if (this.project) {
        var item = this.getMLProjects.filter(function (x) {
          return x.id == _this2.project;
        });
        if (item.length > 0) {
          return item[0].business + "-" + item[0].name;
        }
      }
    }
  },
  created: function created() {
    var _this3 = this;
    console.log(this.$router.currentRoute.meta.mode, this.$router.currentRoute.params.request_id);
    this.mode = this.$router.currentRoute.meta.mode;
    var params2 = {
      domain: window.userInfo.domain
    };
    AnalyticService.get_configs(params2).then(function (response) {
      _this3.mlops_configs = response.data;
      console.log(response);
    });
    AnalyticService.get_projects(params2).then(function (response) {
      _this3.mlops_projects = response.data;
      console.log(response);
      _this3.onChangeProject(null);
    });
    if (this.mode == 'view' || this.mode == 'edit') {
      var params = {
        domain: window.userInfo.domain,
        request_id: this.$router.currentRoute.params.request_id
      };
      AnalyticService.get_request(params).then(function (response) {
        _this3.pipelines = response.data.pipelines;
        _this3.pipelines.forEach(function (pipeline) {
          var arrayParaTabla = Object.entries(pipeline.labels).map(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 2),
              label = _ref3[0],
              value = _ref3[1];
            return {
              label: label,
              value: value
            };
          });
          pipeline.labels = arrayParaTabla;
        });
        _this3.config = response.data.config_id;
        _this3.project = response.data.project_id;
        _this3.key_aux++;
        _this3.model_view = response.data;
        console.log(response);
        _this3.onChangeProject(null);
      });
    }

    //this.getInitialConfig()
    //this.subscribeObserver()
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['setShowLoading'])), {}, {
    onVolver: function onVolver() {
      this.$router.push({
        name: 'ml_requests'
      });
    },
    getNameFolderPipe: function getNameFolderPipe(name) {
      if (name) {
        return name.toLowerCase().replace(" ", "_");
      }
      return "";
    },
    addItemEnvar: function addItemEnvar() {
      this.envars.push({});
    },
    addItem: function addItem() {
      this.parameters.push({});
    },
    downloadFile: function downloadFile(route, name) {
      var params = {
        route: route
      };
      AnalyticService.download_file(params).then(function (response) {
        console.log(response);
        var archivoContenido = response;
        var blob = new Blob([archivoContenido], {
          type: 'application/octet-stream'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    getarchivo: function getarchivo(value, index) {
      console.log(value);
      this.archivos[index].archivo = value;
      this.archivos[index].name = value.name;
      this.key_archivos += 1;
      console.log('dbug', value, index);
      console.log('desde child', this.pdf);
      this.key_envars += 1;
    },
    getpython: function getpython(value) {
      this.pipeline_aux.python = value;
    },
    getyaml: function getyaml(value) {
      this.pipeline_aux.yaml = value;
    },
    convertirArchivoAURL: function convertirArchivoAURL(archivo, name, code) {
      var _this4 = this;
      return new Promise(function (resolve, reject) {
        tasks.lockScreen.lock();
        console.log('subida');
        var file = archivo;
        var date = new Date().toISOString().slice(0, 19).replace('T', '').replace(/[-:]/g, '');
        var route = 'mlops/' + code + '/' + name + '/' + file.name.split('.').slice(0, -1).join('.') + date;
        var ref = firebase.storage().ref(route);
        var upload = ref.put(file);
        upload.on('state_changed', function progress(snapshot) {
          console.warn(snapshot.bytesTransferred / snapshot.totalBytes * 100);
        }, function error(error) {
          console.error(error);
          tasks.lockScreen.unlock();
          reject(error);
        }, function () {
          _this4.all_routes.push(route);
          var aux = {
            name: file.name,
            route: route
          };
          tasks.lockScreen.unlock();
          resolve(aux);
        });
      });
    },
    saveRequest: function saveRequest() {
      var _this5 = this;
      if (this.pipelines.length == 0) {
        return;
      }
      if (!this.$refs.form.validate()) {
        return;
      }
      this.all_routes = [];
      var date = new Date().toISOString().slice(0, 19).replace('T', '').replace(/[-:]/g, '');
      var code = 'S' + date + '-' + Array.from({
        length: 3
      }, function () {
        return String.fromCharCode(65 + Math.floor(Math.random() * 26));
      }).join('');
      this.pipelines.forEach(function (pipeline) {
        var labelsObj = {};
        pipeline.labels.forEach(function (item) {
          labelsObj[item.label] = item.value;
        });
        pipeline.labels = labelsObj;
      });
      var promises = this.pipelines.map(/*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(objeto) {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                if (!objeto.python) {
                  _context2.n = 2;
                  break;
                }
                _context2.n = 1;
                return _this5.convertirArchivoAURL(objeto.python, objeto.name, code);
              case 1:
                objeto.python_file = _context2.v;
              case 2:
                if (!objeto.yaml) {
                  _context2.n = 4;
                  break;
                }
                _context2.n = 3;
                return _this5.convertirArchivoAURL(objeto.yaml, objeto.name, code);
              case 3:
                objeto.yaml_file = _context2.v;
              case 4:
                if (!Array.isArray(objeto.archivos)) {
                  _context2.n = 5;
                  break;
                }
                _context2.n = 5;
                return Promise.all(objeto.archivos.map(/*#__PURE__*/function () {
                  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(item) {
                    return _regenerator().w(function (_context) {
                      while (1) switch (_context.n) {
                        case 0:
                          if (!item.archivo) {
                            _context.n = 2;
                            break;
                          }
                          _context.n = 1;
                          return _this5.convertirArchivoAURL(item.archivo, objeto.name, code);
                        case 1:
                          item.archivo_file = _context.v;
                        case 2:
                          return _context.a(2);
                      }
                    }, _callee);
                  }));
                  return function (_x2) {
                    return _ref5.apply(this, arguments);
                  };
                }()));
              case 5:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref4.apply(this, arguments);
        };
      }());
      Promise.all(promises).then(function () {
        console.log('para backend', _this5.pipelines);
        _this5.pipelines.forEach(function (pipe) {
          pipe.envars.forEach(function (x) {
            if (x.is_file) {
              if (x.file.name == x.file.route) {
                // buscar route
                var fi = pipe.archivos.filter(function (y) {
                  return y.name == x.file.name;
                });
                if (fi.length > 0) {
                  x.file.route = fi[0].archivo_file.route;
                }
              }
            }
          });
        });
        console.log(_this5.pipelines);
        var params = {
          domain: window.userInfo.domain,
          type: 'VERTEX_PIPELINE',
          pipelines: _this5.pipelines,
          applicant: window.userInfo.email,
          code: code,
          all_routes: _this5.all_routes,
          project_id: _this5.project,
          config_id: _this5.config
        };
        AnalyticService.save_request(params).then(function (response) {
          console.log(response);
          if (response.success) {
            tasks.toast.success('Solicitud generada correctamente con código: ' + response.data);
            _this5.$router.push({
              name: 'ml_requests'
            });
          } else {
            tasks.toast.error('No se pudo generar la solicitud. Intente nuevamente.');
          }
        });
      });
    },
    updateRequest: function updateRequest() {
      var _this6 = this;
      if (this.pipelines.length == 0) {
        return;
      }
      if (!this.$refs.form.validate()) {
        return;
      }
      this.all_routes = [];
      var date = new Date().toISOString().slice(0, 19).replace('T', '').replace(/[-:]/g, '');
      var code = this.model_view.code;
      this.pipelines.forEach(function (pipeline) {
        var labelsObj = {};
        pipeline.labels.forEach(function (item) {
          labelsObj[item.label] = item.value;
        });
        pipeline.labels = labelsObj;
      });
      var promises = this.pipelines.map(/*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(objeto) {
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                if (!objeto.python) {
                  _context4.n = 2;
                  break;
                }
                _context4.n = 1;
                return _this6.convertirArchivoAURL(objeto.python, objeto.name, code);
              case 1:
                objeto.python_file = _context4.v;
              case 2:
                if (!objeto.yaml) {
                  _context4.n = 4;
                  break;
                }
                _context4.n = 3;
                return _this6.convertirArchivoAURL(objeto.yaml, objeto.name, code);
              case 3:
                objeto.yaml_file = _context4.v;
              case 4:
                if (!Array.isArray(objeto.archivos)) {
                  _context4.n = 5;
                  break;
                }
                _context4.n = 5;
                return Promise.all(objeto.archivos.map(/*#__PURE__*/function () {
                  var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(item) {
                    return _regenerator().w(function (_context3) {
                      while (1) switch (_context3.n) {
                        case 0:
                          if (!item.archivo) {
                            _context3.n = 2;
                            break;
                          }
                          _context3.n = 1;
                          return _this6.convertirArchivoAURL(item.archivo, objeto.name, code);
                        case 1:
                          item.archivo_file = _context3.v;
                        case 2:
                          return _context3.a(2);
                      }
                    }, _callee3);
                  }));
                  return function (_x4) {
                    return _ref7.apply(this, arguments);
                  };
                }()));
              case 5:
                return _context4.a(2);
            }
          }, _callee4);
        }));
        return function (_x3) {
          return _ref6.apply(this, arguments);
        };
      }());
      Promise.all(promises).then(function () {
        console.log('para backend', _this6.pipelines);
        _this6.pipelines.forEach(function (pipe) {
          pipe.envars.forEach(function (x) {
            if (x.is_file) {
              if (x.file.name == x.file.route) {
                // buscar route
                var fi = pipe.archivos.filter(function (y) {
                  return y.name == x.file.name;
                });
                if (fi.length > 0) {
                  console.log(fi[0].archivo_file);
                  x.file.route = fi[0].archivo_file.route;
                }
              }
            }
          });
        });
        console.log(_this6.pipelines);
        var params = {
          domain: window.userInfo.domain,
          type: 'VERTEX_PIPELINE',
          pipelines: _this6.pipelines,
          request_id: _this6.model_view.request_id,
          applicant: window.userInfo.email,
          code: code,
          all_routes: _this6.all_routes,
          project_id: _this6.project,
          config_id: _this6.config,
          delete_pipelines: _this6.delete_pipelines
        };
        AnalyticService.update_request(params).then(function (response) {
          console.log(response);
          if (response.success) {
            tasks.toast.success('La solicitud fue actualizada.');
            _this6.$router.push({
              name: 'ml_requests'
            });
          } else {
            tasks.toast.error('No se pudo actualizar la solicitud. Intente nuevamente.');
          }
        });
      });
    },
    addItem_pipe: function addItem_pipe() {
      this.pipelines.push({});
    },
    addItem_archivo: function addItem_archivo() {
      this.archivos.push({});
    },
    addItem_label: function addItem_label() {
      this.labels.push({});
    },
    saveConfig: function saveConfig() {
      if (!this.$refs.formDialog.validate()) {
        return;
      }
      if (this.indiceModal !== -1) {
        this.pipeline_aux.parameters = this.parameters;
        this.pipeline_aux.labels = this.labels;
        this.pipeline_aux.archivos = this.archivos;
        this.pipeline_aux.envars = this.envars;
        this.pipelines[this.indiceModal] = _objectSpread({}, this.pipeline_aux);
        console.log('pipelines', this.pipelines);
      }
      this.indiceModal = -1;
      this.$refs[this.DIALOG_PIPELINE].onClose();
      this.key_table++;
    },
    openDialogPipeline: function openDialogPipeline(data, index) {
      this.indiceModal = index;
      console.log(data);
      if (data) {
        this.pipeline_aux = Object.assign({}, data);
        if (this.pipeline_aux.parameters) this.parameters = this.pipeline_aux.parameters.slice();else this.parameters = [];
        if (this.pipeline_aux.archivos) this.archivos = this.pipeline_aux.archivos.slice();else this.archivos = [];
        if (this.pipeline_aux.labels) this.labels = this.pipeline_aux.labels.slice();else this.labels = [];
        if (this.pipeline_aux.envars) this.envars = this.pipeline_aux.envars.slice();else this.envars = [];
      } else {
        this.pipeline_aux = {};
      }
      this.$refs[this.DIALOG_PIPELINE].onOpen();
    },
    removeItem: function removeItem(data) {
      var record_details = [];
      var index = 0;
      var _iterator = _createForOfIteratorHelper(this.parameters),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var detail = _step.value;
          if (data.index !== index) {
            record_details.push(detail);
          } else {}
          index += 1;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.parameters = record_details;
    },
    removeItem_archivo: function removeItem_archivo(data) {
      var record_details = [];
      var index = 0;
      var _iterator2 = _createForOfIteratorHelper(this.archivos),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var detail = _step2.value;
          if (data.index !== index) {
            record_details.push(detail);
          } else {}
          index += 1;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this.archivos = record_details;
    },
    removeItem_envar: function removeItem_envar(data) {
      var record_details = [];
      var index = 0;
      var _iterator3 = _createForOfIteratorHelper(this.envars),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var detail = _step3.value;
          if (data.index !== index) {
            record_details.push(detail);
          } else {}
          index += 1;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      this.envars = record_details;
    },
    removeItem_pipe: function removeItem_pipe(data) {
      console.log('entra funcion', data);
      var record_details = [];
      var index = 0;
      var _iterator4 = _createForOfIteratorHelper(this.pipelines),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var detail = _step4.value;
          if (data !== index) {
            record_details.push(detail);
          } else {
            this.delete_pipelines.push(detail);
          }
          index += 1;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      this.pipelines = record_details;
    },
    removeItem_label: function removeItem_label(data) {
      var record_details = [];
      var index = 0;
      var _iterator5 = _createForOfIteratorHelper(this.labels),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var detail = _step5.value;
          if (data.index !== index) {
            record_details.push(detail);
          } else {}
          index += 1;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      this.labels = record_details;
    },
    onRejectRequest: function onRejectRequest() {
      this.response = '';
      this.$refs['MODAL_CONFIRM_REJECT'].onOpen();
    },
    onApproveRequest: function onApproveRequest() {
      this.response = '';
      this.$refs['MODAL_CONFIRM_APPROVE'].onOpen();
    },
    onConfirmApprove: function onConfirmApprove(event) {
      var _this7 = this;
      if (event) {
        if (!this.response) {
          tasks.toast.error('Debe ingresar una respuesta.');
          return;
        }
        var data = {
          id: this.$router.currentRoute.params.request_id,
          status: 'APPROVED',
          response: this.response
        };
        mlops_service.changeState(data).then(function (response) {
          _this7.$refs['MODAL_CONFIRM_APPROVE'].onClose();
          if (response.success) {
            tasks.toast.success('La solicitud se ha aprobado correctamente.');
            _this7.goRequests();
          } else {
            tasks.toast.error('No se ha podido aprobar la solicitud.');
          }
        });
      } else {
        this.$refs['MODAL_CONFIRM_APPROVE'].onClose();
      }
    },
    onConfirmReject: function onConfirmReject(event) {
      var _this8 = this;
      if (event) {
        if (!this.response) {
          tasks.toast.error('Debe ingresar una respuesta.');
          return;
        }
        var data = {
          id: this.$router.currentRoute.params.request_id,
          status: 'REJECTED',
          response: this.response
        };
        mlops_service.changeState(data).then(function (response) {
          _this8.$refs['MODAL_CONFIRM_REJECT'].onClose();
          if (response.success) {
            tasks.toast.success('La solicitud se ha rechazado correctamente.');
            _this8.goRequests();
          } else {
            tasks.toast.error('No se ha podido rechazar la solicitud.');
          }
        });
      } else {
        this.$refs['MODAL_CONFIRM_REJECT'].onClose();
      }
    },
    goRequests: function goRequests() {
      this.$router.push({
        name: 'ml_requests'
      });
    },
    onChangeProject: function onChangeProject(event) {
      var _this9 = this;
      var items = this.mlops_projects.find(function (x) {
        return x.id == _this9.project;
      }) ? this.mlops_projects.find(function (x) {
        return x.id == _this9.project;
      }).archivos : [];
      console.log(items, this.project);
      //this.archivos_env = items ? items: []
    }
  })
};